import { UPDATE_PACKAGE_ID } from '../constants/actionTypes'

export default (state = '', action) => {
    switch (action.type) {
        case UPDATE_PACKAGE_ID:
            return action.payload
        default:
            return state
    }
}
